import {Injectable} from "@angular/core";
import {ErrorResponseModel} from "../models/response/response.model";
import {ToasterService} from "angular2-toaster/angular2-toaster";
import 'jquery-serializejson';
import 'jquery-validation';

declare var jQuery:any;

@Injectable()
export class ValidationService {

    constructor(
        public toasterService: ToasterService
    ) {
        jQuery.validator.addMethod("letters", function(value, element) {
            return this.optional(element) || value == value.match(/^[a-zA-Z\s]+$/);
        }, "Please, enter only letters.");

        jQuery.validator.addMethod("postCode", function(value, element) {
            return this.optional(element) || value == value.match(/[A-Z]{1}[0-9]{1}[A-Z]{1}\s[0-9]{1}[A-Z]{1}[0-9]{1}/);
        }, "Wrong postal code. Use fromat A1A 1A1.");
    }

    public showError(error: any, form?) {
        let errorData = new ErrorResponseModel(error.json());

        if (errorData.errors && errorData.errors.length) {
            if (!form) {
                let firstError = errorData.errors[0];
                this.toasterService.pop('error', 'Error', firstError.message);

            } else {
                this.toasterService.pop('error', 'Error', 'Some fields has errors');
                let errorFields = errorData.convertToHash();

                $(form).data('validator').showErrors(errorFields);
            }

        } else {
            this.toasterService.pop('error', 'Error', errorData.message);
        }
    }


    static getValidatorErrorMessage(validatorName: string, validatorValue?: any) {

        let config = {
            'required': 'This field is required.',
            'invalidCreditCard': 'Is invalid credit card number',
            'invalidEmailAddress': 'Invalid email address',
            'invalidPassword': 'Invalid password. Password must be at least 6 characters long, and contain a number.',
            'minlength': `Minimum length ${validatorValue.requiredLength}`,
            'maxlength': `Maximum length ${validatorValue.requiredLength}`,
            'rangeLength': `Please enter a value between ${validatorValue.requiredLength} and ${validatorValue.requiredLength} characters long.`,
            'min': `Please enter a value greater than or equal to ${validatorValue.requiredLength}.`,
            'gt': 'gt',
            'max': `Please enter a value greater than or equal to ${validatorValue.requiredLength}.`,
            'lt': 'lt',
            'range': 'range',
            'digits': 'Please enter only digits.',
            'number': 'Please enter a valid number.',
            'url': 'Please enter a valid URL.',
            'email': 'Please enter a valid email address.',
            'date': 'Please enter a valid date.',
            'minDate': 'minDate',
            'maxDate': 'maxDate',
            'dateISO': 'Please enter a valid date ( ISO ).',
            'creditCard': 'creditCard',
            'json': 'json',
            'base64': 'base64',
            'phone': 'phone',
            'uuid': 'uuid',
            'equal': 'equal',
            'notEqual': 'notEqual',
            'equalTo': 'Please enter the same value again.',
            'notEqualTo': 'notEqualTo',
        };

        return config[validatorName];
    }

    static creditCardValidator(control) {
        // Visa, MasterCard, American Express, Diners Club, Discover, JCB
        if (control.value.match(/^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11})$/)) {
            return null;
        } else {
            return { 'invalidCreditCard': true };
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/services/validation.service.ts